// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

// utilities
// import cx from 'classnames';
import { get, pick } from 'lodash';

import ProgressComponent from '../../../../../../common/components/C_ProgressComponent';
import TextArea from '../../../../../../common/components/c_TextArea';

// needed to replace '\n' with actual newline
const newLine = /\\n/g;

const jobDescritionBottom = 'Please remember to proofread before you submit.';

@connect(store => ({
  labels: get(store.labels, 'Application', {}),
}), null, null, {withRef: true})
export default class CareerSummary extends ProgressComponent {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    model: PropTypes.string.isRequired,
    staticData: PropTypes.object.isRequired,
    tempState: PropTypes.object.isRequired,
    validation: PropTypes.object.isRequired,
    errorUpdate: PropTypes.func.isRequired,
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      validation: Object.assign({}, pick(props.validation, ['careerSummary']))
    };
  }

  handleTextAreaUI(prop) {
    return {
      // need to replace '\n' with actual newline
      key: `${prop}_${this.props.profile[prop]}`,
      defaultValue: (this.props.profile[prop] || '').replace(newLine, '\n'),
      isDirty: !!get(this.state, `validation.${prop}.errors[0]`, false),
      errorText: get(this.state, `validation.${prop}.errors[0]`),
      onBlur: this.validateUpdate(this.props.model, prop, this.updateTempState)
    };
  }

  render() {
    return (
      <div className='application-section-container career-summary clearfix'>
        <div
          data-id='Heading'
          className='form-heading'
        >
          Career Summary
        </div>
        {
          !this.props.submitted
          &&
          <div
            data-id='Prompt'
            className='form-text'
          >
            Please write a paragraph (up to 800 characters) summarizing your career experience.
            Your career summary should be a concise overview of your entire career highlighting years of experience,
            type of work roles and responsibilities, and if you had management duties.
            If you would like an example of what a career summary might look like, click on Example.
          </div>
        }
        <TextArea
          className='career-summary-text'
          data-id='Career Summary textarea'
          descriptionBottom={jobDescritionBottom}
          maxLength={800}
          capitalizedSentences
          showCharacterCount
          exampleText={this.props.submitted ? '' : get(this.props.labels, 'careerSummaryExample')}
          {...this.handleTextAreaUI('careerSummary')}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/r_ApplicationForm/Experience/c_CareerSummary/index.js